<script lang="ts">
  import Icon from '../../../common/components/Icon.svelte';
  import { productDetails } from '../../store/pdp_store';
  export let name;
  export let fontSize = '14';
  export let iconUrl;
  export let width = '12';
  export let height = '12';
  export let variantOption;

  // const { pageTemplate } = getAppConfig();
  $: code = $productDetails.code;
</script>

<section class="tag black" style="font-size: {fontSize}px;" class:selected={code === variantOption.code}>
  {#if iconUrl && iconUrl.length > 0}
    <div style="width:{width}px; margin-bottom: 1px">
      <Icon glyph={iconUrl} type="url" size={height} />
    </div>
  {/if}
  <span class="text font-weight-medium" class:selected={code === variantOption.code}>{name}</span>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .tag {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $functional-yellow-04;
    width: fit-content;

    &.black {
      color: $primary-black;
      border: 1px solid $secondary-gray-02;
      background-color: $primary-white;
      white-space: nowrap;
      border-radius: 8px;
      height: 36px;
      cursor: pointer;
      gap: 6px;
      padding: 10px 20px;

      &.selected {
        border: 1px solid $icon-only-icon-blue;
      }

      @include desktop-max-width {
        gap: 4px;
      }
    }

    .text {
      color: $color-bg-black;
      &.selected {
        font-weight: 700;
      }
    }
  }
  a.copy-code {
    text-decoration: none;
    color: $icon-only-icon-blue;
  }
</style>
